import React from 'react';

export const EyeSvg = () => (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M12 10a2 2 0 1 0 0 4 2 2 0 0 0 0-4m-4 2a4 4 0 1 1 8 0 4 4 0 0 1-8 0"
            clipRule="evenodd"
        />
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M4.054 12a10.7 10.7 0 0 0 1.928 3.269C7.234 16.7 9.136 18 12 18s4.766-1.3 6.018-2.731A10.7 10.7 0 0 0 19.946 12a10.7 10.7 0 0 0-1.928-3.269C16.766 7.3 14.863 6 12 6S7.234 7.3 5.982 8.731A10.7 10.7 0 0 0 4.054 12m.422-4.586C6.016 5.653 8.434 4 12 4s5.983 1.653 7.524 3.414a12.6 12.6 0 0 1 2.384 4.14c.096.293.096.6 0 .892-.18.542-.864 2.4-2.384 4.14C17.983 18.347 15.565 20 12 20s-5.983-1.653-7.524-3.415a12.6 12.6 0 0 1-2.384-4.14 1.4 1.4 0 0 1 0-.89c.179-.543.864-2.402 2.384-4.14"
            clipRule="evenodd"
        />
    </svg>
);
